<template>
  <!-- Loaded Externals
  <h1>bypass {{ bypass }}</h1>-->
</template>

<script>
import config from '@/config';
let d, s;

export default {
	name: 'loadExternals',
  data: function() {
    return {
      bypassw: this.$route.meta.bypassExternals,
      requireSocials: this.$route.meta.requireSocials,
      requireStripe: this.$route.meta.requireStripe,
      skipMaps: this.$route.meta.skipMaps,
      secondLoads: []
    }
  },
	computed: {
  },
  watch: {
    '$route' (to, from) {
      // react to route changes...
      this.bypassw = to.meta.bypassExternals;
      this.requireSocials = to.meta.requireSocials;
      this.requireStripe = to.meta.requireStripe;
      this.skipMaps = to.meta.skipMaps;
      this.secondLoad();
    }
  },

	mounted: async function() {
    this.firstLoad();
  },
  methods: {
    firstLoad: function() {
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-P55WFCV');

      window.$crisp=[];window.CRISP_WEBSITE_ID="8b2ccbbd-7d92-4ea1-b11f-b3ac2aa2f552";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();

      window.twttr = (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0],
         t = window.twttr || {};
        if (d.getElementById(id)) return t;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];
        t.ready = function(f) {
         t._e.push(f);
        };
        return t;
      }(document, "script", "twitter-wjs"));
      this.secondLoad();
    },
    secondLoad: async function(){
      let that = this;
      await Promise.all([
        'https://js.stripe.com/v3/',
        "https://platform.linkedin.com/in.js",
        "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.8",
        "https://apis.google.com/js/api.js",
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDZnOUhXYvsXhP_erH4uw8u2Nzw3MzEx8s&amp&libraries=places",
      ].map(jsfile => {
        if (that.secondLoads.indexOf(jsfile) !== -1) { // avoid reload on page change
          return true;
        }
        const script = document.createElement('script');
        script.src = jsfile;
        //console.log("loaded ",jsfile);
        if (jsfile.indexOf('linkedin') !== -1) {
          script.innerHTML = 'api_key:   78dyng07s6xrbc';
        }
        //console.log(that.requireStripe,jsfile);
        if (that.requireStripe !== true && jsfile.indexOf('js.stripe') !== -1) {
          // not loading
          //console.log('notloading');
        } else if (typeof google === 'object' && typeof google.maps === 'object' && jsfile.indexOf('maps.googleapis.com') !== -1) {
          // not reloading
        } else if (that.skipMaps && jsfile.indexOf('maps.googleapis.com') !== -1) {
          // not loading
        } else {
          document.head.appendChild(script);
          that.secondLoads.push(jsfile);
        }
      }));
      if (that.requireSocials) {
        setTimeout(async function(){
          FB.init({
        		appId      : config.social.fbAppId,
        		cookie     : true,
        		xfbml      : true,
        		version    : 'v2.8'
        	});
        	FB.AppEvents.logPageView();
          window.FB = FB;
          window.gapi.load('auth2', () => {
        		window.gapi.auth2.init({
        			client_id: config.social.googleAppId,
        			scope: 'profile email'
        		});
        	});
        },1000);

        /*
        import('../libs/providers/fb.js').then(m => {
          console.log('Loaded ',m);
        });
        */
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/loadExternals.vue